import React, {useEffect} from 'react';
import {Button} from '@lightricks/react-design-system';
import {ButtonProps} from '@lightricks/react-design-system/dist/components/button/ButtonProps';
import {ActionItem, ActionsBar} from './ActionsBar';
import AvatarsStack from './AvatarsStack';
import styles from './CreatorsActionsBar.module.scss';

export type CreatorsActionsProps = {
  avatarUrls: string[];
  /** Effective selected creators count for bulk actions (can represent all filter-matching creators). */
  selectedCount?: number;
  actionItems: ActionItem[];
  closeButtonProps: ButtonProps;
  closeButtonText: string;
  closeButtonOnClick: () => void;
  onPresentedOrDismissed?: (
    presentedOrDismissed: 'presented' | 'dismissed',
    name: string
  ) => void;
  renderHeader?: () => React.ReactNode;
};

function CreatorsActionsBar({
  avatarUrls,
  selectedCount,
  actionItems,
  closeButtonProps,
  closeButtonText,
  closeButtonOnClick,
  onPresentedOrDismissed,
  renderHeader,
}: CreatorsActionsProps) {
  useEffect(() => {
    onPresentedOrDismissed?.('presented', 'selected-creators-action-bar');
    return () => {
      onPresentedOrDismissed?.('dismissed', 'selected-creators-action-bar');
    };
  }, []);
  return (
    <div className={styles.creatorsActionsBarContainer}>
      {renderHeader?.()}
      <div className={styles.creatorsActionsBar}>
        <div className={styles.leftZone}>
          <AvatarsStack avatarUrls={avatarUrls} count={selectedCount} />
        </div>
        <div className={styles.centerZone}>
          <ActionsBar actionItems={actionItems} />
        </div>
        <div className={styles.rightZone}>
          <Button {...closeButtonProps} onClick={closeButtonOnClick}>
            {closeButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CreatorsActionsBar;
